<template>
  <div>

    <Drawer :mask-closable="true" class="demo-drawer-prime"  @on-close="reset()"
            title="Upload File" v-model="$parent.uploadFileDialog" width="500">

      <div>
        <input id="file" @change="onSelectFile()" type="file" style="display: none"/>
        <div class="transferType mb-3">
          <div :class="fileDataURI?'':'image-box'" @click="openFile" class="mx-auto">
            <div v-if="fileDataURI && file.type==='application/pdf'">
              <div style="width: 250px; height: 250px;" class="mx-auto mb-4">
                <img src="../assets/pdf.png" alt="" class="w-100" >
              </div>
              <Button @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI" target="_blank">PREVIEW</Button>
            </div>
            <div v-else-if="fileDataURI" class="selected-image">
              <img :src="fileDataURI"  class="w-100">
            </div>
            <i class="fas fa-cloud-upload-alt" v-if="!fileDataURI"></i>
          </div>
          <div style="text-align: center">
          <Button @click="uploadFile" :disabled="!file" class="upload-btn">Upload</Button>
          </div>
        </div>
      </div>
    </Drawer>

  </div>
</template>

<script>
  import {Constants} from "../Constants/Constant";
  import { NetworkCommunicator} from "../plugins/NetworkResourceHandler";

  export default {
    name: "UploadFile",
    data:function () {
      return{
        file: '',
        fileDataURI: '',
      }
    },
    methods:{
      openFile(){
        document.getElementById('file').click();
      },
      onSelectFile(){
        this.file = document.getElementById('file').files[0];
        this.fileDataURI = window.URL.createObjectURL(this.file);
      },
      uploadFile () {
        let self = this
        let formData = new FormData()
        formData.append('doc[]', this.file)

        NetworkCommunicator('POST', Constants.api_url + 'upload', false, formData).then(res => {
          if(res.flag){
            this.$emit('fileResponseData', res.data.success[0])
            this.reset()
          }else{
            this.$Message.error(res.message);
          }
        }).catch(function(err){
          console.log('Upload File Error', err)
          this.$Message.error('File Upload failed');
        })
      },
      reset: function(){
        this.file = ''
        this.fileDataURI = ''
      },
    }
  }
</script>

<style scoped>
  .image-box{
    height: 250px;
    width: 350px;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    text-align: center;
    line-height: 250px;
    margin: auto;
    font-size: 30px;
  }
  .icon-cloud{
    font-size: 50px;
    color: grey;
  }
  .selected-image{
    width: 250px;
    height: 250px;
    margin:15px auto;
    cursor: pointer;
  }
  .w-100{
    width: 100%;
  }
  .upload-btn{
    margin-top: 10px;
  }
</style>
